import { render, staticRenderFns } from "./BasicButtonLongG.vue?vue&type=template&id=5e20db1a&"
import script from "./BasicButtonLongG.vue?vue&type=script&lang=js&"
export * from "./BasicButtonLongG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports